import { gql } from 'apollo-boost';

export const UPLOAD_URLMETA_MEDIA = gql`
    mutation($data: UploadUrlMetaMediaInput!) {
        uploadUrlMetaMedia(data: $data) {
            url
            name
            displayName
            type
            format
            size
            mime
        }
    }
`;



